/** @module Whether the number read from the photo backs a suggestion, as a badge. */
import { Check, TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

import { type Candidate, ocrBacks, type ReviewModel } from "@/features/review/use-review-case";

export function OcrBadge({ model, candidate }: { model: ReviewModel; candidate: Candidate }) {
  const { t } = useTranslation();
  const backs = ocrBacks(model.scan, candidate);
  if (backs === null || candidate.picked) return null;
  return backs ? (
    <span className="badge badge-gain">
      <Check />
      {t("review.ocrMatches")}
    </span>
  ) : (
    <span className="badge badge-warn">
      <TriangleAlert />
      {t("review.ocrDiffers")}
    </span>
  );
}
